import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pb-3 text-left" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "text-left"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: "existInsuranceLabel",
  class: "pb-3 text-left",
  textContent: 'Hvilket forsikringsselskab var du senest hos?'
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "text-left"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = { key: "validNow" }
const _hoisted_16 = {
  class: "text-left",
  key: "validNowErr"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = {
  key: "insuranceTerminationInfoBox",
  class: "highlights fill mb-4 mt-3"
}
const _hoisted_20 = { class: "text-left" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvor mange forsikringsskader har du haft de seneste 2 år?'
}, null, -1)
const _hoisted_23 = {
  class: "text-left mt-n3",
  key: "skaderErr"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg antal skader'
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: "RkiLabel",
  class: "pb-3 text-left"
}
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  class: "text-left",
  key: "rkiErr"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_30 = {
  key: "restanceLabel",
  class: "mt-3 pb-3 text-left"
}
const _hoisted_31 = {
  key: "restanceErr",
  class: "text-left"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isChildAccident)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", { innerHTML: _ctx.existingInsuranceLabel }, null, 8, _hoisted_3),
            (_ctx.cms.terminationInfoPopover)
              ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                  key: 0,
                  type: "icon",
                  class: "page-component__popover",
                  buttonClass: "popover__icon popover__icon__info",
                  innerData: _ctx.cms.terminationInfoPopover
                }, null, 8, ["innerData"]))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
              key: 'existInsurance_' + inx
            }, [
              _createVNode(_component_RadioComponent, {
                name: 'existInsurance',
                id: 'existInsurance' + item.value,
                inputValue: item.value + '',
                preSelect: _ctx.model.additionalInfo.existInsurance,
                trackingLabel: _ctx.existingInsuranceLabel,
                onRadioComponent: _ctx.handleRadioClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.displayValue), 1)
                ]),
                _: 2
              }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
            ], 2))
          }), 128)),
          (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.existInsurance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (!_ctx.isChildAccident && _ctx.model.additionalInfo.existInsurance === 'ja')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SelectModalComponent, {
          key: "existingInsurance",
          id: "existingInsurance",
          name: "existingInsurance",
          preSelect: _ctx.model.additionalInfo.existingInsurance,
          innerData: _ctx.cms.insuranceCompanies,
          selected: _ctx.model.additionalInfo.existingInsurance !== undefined,
          placeholder: "Vælg forsikringsselskab",
          visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
          errorMsgOverride: "Du skal vælge et forsikringsselskab",
          "onSelectModalComponent:selected": _ctx.selectExistingInsuranceFamily
        }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]), [
          [_vShow, !_ctx.isChildAccident && _ctx.model.additionalInfo.existInsurance === 'ja']
        ])
      ]),
      _: 1
    }),
    (_ctx.showPersonsBlock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.familyInfo.personCountId + 1, (inx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'ch' + inx
            }, [
              (_openBlock(), _createBlock(_TransitionGroup, {
                name: "slide-simple",
                key: 'cc' + (inx - 1)
              }, {
                default: _withCtx(() => [
                  (_ctx.showPerson(inx - 1))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 'name' + (inx - 1),
                        class: "h2 text-left pt-3",
                        textContent: _toDisplayString(_ctx.getName(inx - 1))
                      }, null, 8, _hoisted_9))
                    : _createCommentVNode("", true),
                  (_ctx.showPerson(inx - 1))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 'existInsurance' + (inx - 1)
                      }, [
                        _createElementVNode("div", {
                          class: "pb-3 text-left",
                          innerHTML: _ctx.getExistingInsuranceLabel(inx - 1)
                        }, null, 8, _hoisted_10),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inxJaNej) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([inxJaNej + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                            key: 'existInsurance' + inxJaNej
                          }, [
                            _createVNode(_component_RadioComponent, {
                              name: 'existInsurance' + (inx - 1),
                              id: 'existInsurance' + (inx - 1) + item.value,
                              inputValue: item.value,
                              preSelect: _ctx.model.familyInfo['existInsurance' + (inx - 1)],
                              trackingLabel: _ctx.getExistingInsuranceLabel(inx - 1),
                              onRadioComponent: _ctx.handleRadioClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.displayValue), 1)
                              ]),
                              _: 2
                            }, 1032, ["name", "id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                          ], 2))
                        }), 128)),
                        (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.familyInfo['existInsurance' + (inx - 1)])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showPerson(inx - 1) && _ctx.model.familyInfo['existInsurance' + (inx - 1)] === 'ja')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 'existInsuranceLabel' + (inx - 1),
                        class: "pb-3 text-left",
                        textContent: 'Hvilket forsikringsseleskab drejer det sig om'
                      }))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_SelectModalComponent, {
                    key: 'existingInsurance' + (inx - 1),
                    id: 'existingInsurance' + (inx - 1),
                    name: 'existingInsurance' + (inx - 1),
                    preSelect: _ctx.model.familyInfo['existingInsurance' + (inx - 1)],
                    innerData: _ctx.cms.insuranceCompanies,
                    selected: _ctx.model.familyInfo['existingInsurance' + (inx - 1)] !== undefined,
                    placeholder: "Vælg forsikringsselskab",
                    visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                    errorMsgOverride: "Du skal vælge et forsikringsselskab",
                    "onSelectModalComponent:selected": _ctx.selectExistingInsuranceChild
                  }, null, 8, ["id", "name", "preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"])), [
                    [_vShow, _ctx.showPerson(inx - 1) && _ctx.model.familyInfo['existInsurance' + (inx - 1)] === 'ja']
                  ])
                ]),
                _: 2
              }, 1024))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.showPerson(_ctx.model.familyInfo.personCountId + 1))
          ? (_openBlock(), _createElementBlock("div", {
              class: "pb-3 pt-5 text-left",
              textContent: _toDisplayString(
					_ctx.isChildAccident
						? 'Hvornår skal forsikringen gælde fra?'
						: 'Hvornår skal Børnefamilieforsikringen gælde fra?'
				),
              key: "validNowLabel"
            }, null, 8, _hoisted_14))
          : _createCommentVNode("", true),
        (_ctx.showPerson(_ctx.model.familyInfo.personCountId + 1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validNowArray, (item, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.validNowArray.length ? 'pb-3' : 'pb-2']),
                  key: 'validNow' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: "validNow",
                    id: 'validNow' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.additionalInfo.validNow,
                    trackingLabel: 
							_ctx.isChildAccident
								? 'Hvornår skal forsikringen gælde fra?'
								: 'Hvornår skal Børnefamilieforsikringen gælde fra?'
						,
                    onRadioComponent: _ctx.handleRadioClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                ], 2))
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.validNow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", {
              innerHTML: _ctx.cms.insuranceTerminationInfoBox
            }, null, 8, _hoisted_21)
          ])
        ], 512), [
          [_vShow, 
					_ctx.showValidNowOption &&
					_ctx.showPerson(_ctx.model.familyInfo.personCountId + 1) &&
					_ctx.cms.insuranceTerminationInfoBox
				]
        ]),
        (_ctx.model.additionalInfo.validNow === 'nej' && _ctx.showPerson(_ctx.model.familyInfo.personCountId + 1))
          ? (_openBlock(), _createBlock(_component_DatePickerComponent, {
              key: "validFromDate",
              class: "text-left mb-3",
              label: "",
              innerId: "validFromDate",
              innerData: _ctx.model.additionalInfo,
              placeholder: "F.eks. 21-12-2020",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              validationRule: "AfterToday",
              dateLimitIncluded: true
            }, null, 8, ["innerData", "validateOnLoad"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SegmentedControlComponent, {
          key: "skader",
          class: "pb-3",
          id: "skader",
          options: _ctx.skaderOptions,
          labels: _ctx.skaderLabels,
          preSelected: _ctx.model.additionalInfo.skader,
          controlsPerRow: 4,
          onSegmentedComponent: _ctx.handleRadioClick
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]), [
          [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled]
        ]),
        (
					!_ctx.model.pristineStep.get(_ctx.card.name) &&
					!_ctx.model.multipleProducts &&
					_ctx.isInsuranceInfoFilled &&
					!_ctx.model.additionalInfo.skader
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_26, [
          _createElementVNode("span", {
            innerHTML: _ctx.cms.rkiHeader
          }, null, 8, _hoisted_27),
          (_ctx.cms.rkiPopover)
            ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                key: 0,
                type: "icon",
                class: "page-component__popover text-left",
                buttonClass: "popover__icon popover__icon__info",
                innerData: _ctx.cms.rkiPopover
              }, null, 8, ["innerData"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
            key: 'rki' + inx
          }, [
            _createVNode(_component_RadioComponent, {
              name: "rki",
              id: 'rki' + item.value,
              inputValue: item.value,
              preSelect: _ctx.model.additionalInfo.rki,
              trackingLabel: _ctx.cms.rkiHeader,
              onRadioComponent: _ctx.handleRadioClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.displayValue), 1)
              ]),
              _: 2
            }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
          ], 2)), [
            [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
          ])
        }), 128)),
        (!_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.additionalInfo.rki === undefined)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_28, [
              _hoisted_29,
              _withDirectives(_createElementVNode("div", _hoisted_30, [
                _createElementVNode("span", null, _toDisplayString(_ctx.cms.restanceHeader), 1),
                (_ctx.cms.restancePopover)
                  ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                      key: 0,
                      type: "icon",
                      class: "page-component__popover text-left",
                      buttonClass: "popover__icon popover__icon__info",
                      innerData: _ctx.cms.restancePopover
                    }, null, 8, ["innerData"]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, 
						!_ctx.model.multipleProducts &&
						_ctx.isInsuranceInfoFilled &&
						_ctx.skaderOk &&
						_ctx.model.additionalInfo.rki === 'nej'
					]
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                  key: 'restance' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: "restance",
                    id: 'restance' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.additionalInfo.restance,
                    trackingLabel: _ctx.cms.restanceHeader,
                    onRadioComponent: _ctx.handleRadioClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                ], 2)), [
                  [_vShow, 
						!_ctx.model.multipleProducts &&
						_ctx.isInsuranceInfoFilled &&
						_ctx.skaderOk &&
						_ctx.model.additionalInfo.rki === 'nej'
					]
                ])
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.additionalInfo.restance === undefined)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33, 512)), [
                    [_vShow, 
						!_ctx.model.multipleProducts &&
						_ctx.isInsuranceInfoFilled &&
						_ctx.skaderOk &&
						_ctx.model.additionalInfo.rki === 'nej'
					]
                  ])
                : _createCommentVNode("", true)
            ], 512)), [
              [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonTapComponent, {
      class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
      "data-gtm": _ctx.cms.dataGtm,
      "data-gtm-click-text": _ctx.card.routePath
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.getNextCardLinkText()), 1)
      ]),
      _: 1
    }, 8, ["class", "data-gtm", "data-gtm-click-text"])
  ]))
}